import { ButtonBase } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { EVENT_LABELS } from '@tymely/features/Ticket/constants';

import CommentIdWithTooltip from './CommentIdWithTooltip';
import { AuditLog, ToolResponseHeaderProps } from '../types';
import { EventHeaderContainer, EventLabelTypography, EventTextTypography, ExpandIconBox } from '../../styled';

const ToolResponseHeader = ({ kind, eventData, expanded, onToggle }: ToolResponseHeaderProps) => {
    const { comment_id, result_kind, requires_approval, decision_title, status, arg_names, workflow_id, content } =
        eventData.audit_log as AuditLog;

    const textElements = [
        { condition: true, text: result_kind, suffix: ' :' },
        { condition: content && result_kind === 'error', text: content },
        { condition: status !== 'LIVE' && workflow_id !== 0, text: status },
        { condition: workflow_id === 0, text: 'WF0' },
        { condition: result_kind === 'missing-info', text: arg_names },
        { condition: requires_approval, text: 'need approval:' },
        { condition: decision_title && workflow_id !== 0, text: decision_title, suffix: '' },
    ];

    return (
        <ButtonBase
            onClick={onToggle}
            disableRipple
            sx={{ width: '100%', textAlign: 'left', display: 'block', p: 0, borderRadius: 1 }}
        >
            <EventHeaderContainer>
                <EventLabelTypography variant="subtitle2" fontWeight="bold">
                    {EVENT_LABELS[kind]}:
                </EventLabelTypography>

                {textElements.map(
                    ({ condition, text, suffix }, index) =>
                        condition && (
                            <EventTextTypography key={index} variant="body2">
                                <b>{text}</b>
                                {suffix}
                            </EventTextTypography>
                        ),
                )}

                {eventData?.audit_log?.comment_id && <CommentIdWithTooltip commentId={comment_id} />}
                <ExpandIconBox>{expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}</ExpandIconBox>
            </EventHeaderContainer>
        </ButtonBase>
    );
};

export default ToolResponseHeader;
